import React from "react";
import CpntInscriptionStatus from "../../components/CpntInscriptionStatus";

const PageInscriptionEnCours: React.FC = () => {
  return (
    <CpntInscriptionStatus
      title="INSCRIPTION EN COURS"
      messages={[
        "Votre demande d'inscription a bien été prise en compte.",
        "Nous allons procéder à l'ouverture de votre espace professionnel.",
        "Vous serez informé par e-mail de la validation de votre compte dans les plus brefs délais."
      ]}
      imgAlt="Inscription en cours"
    />
  );
};

export default PageInscriptionEnCours;
